import React from 'react'

export const Clock = (props) => {

  let [state, setState] = React.useState({
    time: new Date(),
  })

  React.useEffect(() => {
    const timerId = setInterval(() => {
      setState(prevState => ({
        ...prevState,
        time: new Date()
      }));
    }, 1000);

    return () => clearInterval(timerId);
  }, [])

  const addZeroBefore = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  return(
    <div className="clock">

      <div className="digital">
        {addZeroBefore(state.time.getHours())} : {addZeroBefore(state.time.getMinutes())} : {addZeroBefore(state.time.getSeconds())}
      </div>
      <div
        className="hour_hand"
        style={{
          transform: `translateX(-2px) rotate(${state.time.getHours() * 30 + state.time.getMinutes() * .5}deg) translateY(-20px)`
        }}
      />
      <div
        className="min_hand"
        style={{
          transform: `translateX(-1px) rotate(${state.time.getMinutes() * 6}deg) translateY(-30px)`
        }}
      />

      <span className="twelve big"></span>
      <span className="one"></span>
      <span className="two"></span>
      <span className="three big"></span>
      <span className="four"></span>
      <span className="five"></span>
      <span className="six big"></span>
      <span className="seven"></span>
      <span className="eight"></span>
      <span className="nine big"></span>
      <span className="ten"></span>
      <span className="eleven"></span>
    </div>
  )
}
